import { inject, ref } from 'vue';
import {
  fetchOrgReferenceOptions,
  invalidateOrgReferenceOptions,
} from '@/api/orgReferenceApi';

/**
 * Settings org-reference list pattern:
 * - default load: active rows only (profile options)
 * - showInactive toggle: include_inactive=1 for org.manage_* actors
 * - reactivate: Edit modal -> Active toggle -> save (is_active=1)
 * - deactivate: list action (row hidden until Show inactive)
 *
 * See docs/SETTINGS_ORG_REFERENCE_LIST_PATTERN.md
 */
export function useSettingsOrgReferenceList() {
  const showInactive = ref(false);
  const refreshWorkspaceStats = inject('refreshWorkspaceStats', null);

  const fetchOptions = () =>
    fetchOrgReferenceOptions({
      force: true,
      includeInactive: showInactive.value,
    });

  const afterMutation = async (reloadFn) => {
    invalidateOrgReferenceOptions();
    if (typeof reloadFn === 'function') {
      await reloadFn();
    }
    refreshWorkspaceStats?.();
  };

  return {
    showInactive,
    fetchOptions,
    afterMutation,
  };
}
